@let data = model();

@switch (column().key) {
  @case (getColumnKey('change')) {
    <div class="flex flex-row gap-2 whitespace-nowrap">
      <div>
        {{ data.quantityBeforeChange }}
      </div>

      <div class="w-4 shrink-0 text-center">
        {{ data.change < 1 ? '-' : '+' }}
      </div>

      <div class="font-bold">
        @if (data.change < 0) {
          <span class="text-red-600">{{ data.absoluteChange }}</span>
        } @else {
          <span class="text-green-600">{{ data.absoluteChange }}</span>
        }
      </div>

      <div class="w-4 shrink-0 text-center">=</div>

      <div>
        {{ data.quantityAfterChange }}
      </div>
    </div>
  }

  @case (getColumnKey('createdAt')) {
    <span class="whitespace-nowrap">
      {{ data.createdAt | dateFormat: DD_MM_YYYY_HH_MM_SS_SSS }}
    </span>
  }

  @case (getColumnKey('reason')) {
    <app-admin-product-quantity-history-reason-type [type]="data.reason" />
  }

  @case (getColumnKey('order')) {
    @if (isNotNil(data.order)) {
      {{ data.order.number }}
    } @else {
      <app-no-data />
    }
  }

  @default {
    <app-table-body-no-reference-cell [columnKey]="column().key" />
  }
}
